import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import bettingService from "../../../api/services/bettingService";
import { playSong } from "../../common/actions/common.actions";
import { IoIosArrowBack } from "react-icons/io";

const SelectedMathesDetail = ({ setIsLoading }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const { t } = useTranslation();
  const language = localStorage.getItem("language");
  const { selectedMatchesDetail } = useSelector((state) => state.sidebar);

  const [selectedMatches, setSelectedMatches] = useState([]);

  console.log("Selected Matches Detail Rendered with ID: ", selectedMatches);

  const handleSongClick = async () => {
    dispatch(playSong());
  };

  const handleBackClick = async () => {
    await handleSongClick();
    navigate("/selected-matches");
  };

  useEffect(() => {
    setIsLoading(true);
    bettingService
      .bettingHistoryDetails({
        gamblingId: Number(id),
        status: "Inplay",
      })
      .then((response) => response.json())
      .then((data) => {
        if (data) {
          const sortedData = data.slice().sort((a, b) => {
            const dateA = new Date(
              a.eventDate.split(" ")[0].split("-").reverse().join("-") +
                " " +
                a.eventDate.split(" ")[1]
            );
            const dateB = new Date(
              b.eventDate.split(" ")[0].split("-").reverse().join("-") +
                " " +
                b.eventDate.split(" ")[1]
            );
            return dateA - dateB;
          });
          setSelectedMatches(sortedData);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        if (err.response?.status === 401) {
          navigate("/login");
        } else {
          console.error("API request error:", err);
        }
      });
  }, [id, navigate, setIsLoading]);

  return (
    <div className="w-full h-screen flex flex-col bg-gradient-to-br from-[#EAEAEA] via-green-50 to-[#228B22]/10 relative font-myanmarSansPro">
      {/* Header */}
      <div className="relative z-10 bg-gradient-to-r from-[#228B22] via-emerald-600 to-[#1F5F1F] py-2 px-3 shadow-sm">
        <div className="flex items-center">
          <button
            onClick={handleBackClick}
            className="w-8 h-8 mr-2 flex justify-center items-center text-white active:bg-white/20 rounded-lg"
          >
            <IoIosArrowBack size={20} />
          </button>
          <div className="flex-1">
            <h3 className="text-white font-bold text-sm">
              {t("selectedMatches")}
            </h3>
            <p className="text-emerald-100 text-[10px]">Match Details</p>
          </div>
        </div>
      </div>

      {/* Bet ID */}
      <div className="relative z-10 px-3 py-1.5">
        <div className="bg-white/80 rounded-xl px-3 py-1.5 border border-[#228B22]/20 shadow-sm">
          <div className="flex items-center justify-between">
            <span className="text-gray-700 font-semibold text-xs flex items-center">
              <span className="w-1.5 h-1.5 bg-[#228B22] rounded-full mr-1.5"></span>
              Bet ID:
            </span>
            <span className="font-dangrek font-bold text-[#228B22] text-sm">
              {selectedMatchesDetail?.postingNo}
            </span>
          </div>
        </div>
      </div>

      {/* Matches List */}
      <div className="relative z-10 flex-1 overflow-auto px-3">
        <div className="">
          {selectedMatches.map((match, index) => {
            const bettedTeam =
              language === "en" ? match?.bettedTeam : match?.bettedTeamMyan;
            const oppositeTeam =
              language === "en"
                ? match?.oppositeTeamName
                : match?.oppositeTeamNameMyan;

            const isHome = match.isHome;
            const bodyOdd = match.bodyOdd;
            const showOdd = bodyOdd && bodyOdd !== "0";

            const displayGame = match.isHome ? (
              <>
                {/* Home Team */}
                <div className="flex items-center justify-between w-full bg-white/70 rounded-lg px-2 py-1.5 border border-[#228B22]/10">
                  <div className="flex items-center min-w-0 flex-1">
                    <div className="w-2 h-2 bg-[#228B22] rounded-full mr-2 flex-shrink-0"></div>
                    <div className="truncate">
                      <span className="font-bold text-gray-800 text-xs">{bettedTeam}</span>
                      <span className="text-[#FF4500] font-bold text-[10px] ml-1">
                        {match.isHomeBodyOdd &&
                          !match.overs &&
                          !match.under &&
                          `(${bodyOdd})`}
                        {match.overs && ` Gp(${match.goalOdd})`}
                      </span>
                    </div>
                  </div>
                  <div className="bg-[#228B22] text-white px-2 py-0.5 rounded-lg font-bold text-xs flex-shrink-0">
                    {match.homeResult === "NS" ? "-" : match.homeResult}
                  </div>
                </div>

                {/* Away Team */}
                <div className="flex items-center justify-between w-full bg-white/70 rounded-lg px-2 py-1.5 border border-[#228B22]/10 mt-1">
                  <div className="flex items-center min-w-0 flex-1">
                    <div className="w-2 h-2 bg-[#FFD700] rounded-full mr-2 flex-shrink-0"></div>
                    <div className="truncate">
                      <span className="font-bold text-gray-800 text-xs">{oppositeTeam}</span>
                      <span className="text-[#FF4500] font-bold text-[10px] ml-1">
                        {!match.isHomeBodyOdd &&
                          !match.overs &&
                          !match.under &&
                          `(${bodyOdd})`}
                        {match.under && `Gp(${match.goalOdd})`}
                      </span>
                    </div>
                  </div>
                  <div className="bg-[#FFD700] text-gray-900 px-2 py-0.5 rounded-lg font-bold text-xs flex-shrink-0">
                    {match.awayResult === "NS" ? "-" : match.awayResult}
                  </div>
                </div>
              </>
            ) : (
              <>
                {/* Home Team (Opponent) */}
                <div className="flex items-center justify-between w-full bg-white/70 rounded-lg px-2 py-1.5 border border-[#228B22]/10">
                  <div className="flex items-center min-w-0 flex-1">
                    <div className="w-2 h-2 bg-[#FFD700] rounded-full mr-2 flex-shrink-0"></div>
                    <div className="truncate">
                      <span className="font-bold text-gray-800 text-xs">{oppositeTeam}</span>
                      <span className="text-[#FF4500] font-bold text-[10px] ml-1">
                        {match.isHomeBodyOdd &&
                          !match.overs &&
                          !match.under &&
                          `(${bodyOdd})`}
                      </span>
                    </div>
                  </div>
                  <div className="bg-[#FFD700] text-gray-900 px-2 py-0.5 rounded-lg font-bold text-xs flex-shrink-0">
                    {match.homeResult === "NS" ? "-" : match.homeResult}
                  </div>
                </div>

                {/* Away Team (Betted) */}
                <div className="flex items-center justify-between w-full bg-white/70 rounded-lg px-2 py-1.5 border border-[#228B22]/10 mt-1">
                  <div className="flex items-center min-w-0 flex-1">
                    <div className="w-2 h-2 bg-[#228B22] rounded-full mr-2 flex-shrink-0"></div>
                    <div className="truncate">
                      <span className="font-bold text-gray-800 text-xs">{bettedTeam}</span>
                      <span className="text-[#FF4500] font-bold text-[10px] ml-1">
                        {!match.isHomeBodyOdd &&
                          !match.overs &&
                          !match.under &&
                          `(${bodyOdd})`}
                      </span>
                    </div>
                  </div>
                  <div className="bg-[#228B22] text-white px-2 py-0.5 rounded-lg font-bold text-xs flex-shrink-0">
                    {match.awayResult === "NS" ? "-" : match.awayResult}
                  </div>
                </div>
              </>
            );

            return (
              <div
                key={index}
                className="bg-white/80 rounded-xl p-3 border border-[#228B22]/20 shadow-sm mb-1.5"
              >
                {/* Match Date Header */}
                <div className="mb-1.5 pb-1.5 border-b border-[#228B22]/20">
                  <div className="flex items-center">
                    <span className="w-1.5 h-1.5 bg-[#1E90FF] rounded-full mr-1.5"></span>
                    <span className="text-gray-700 font-semibold text-xs">{match.eventDate}</span>
                  </div>
                </div>

                {/* Game Display */}
                <div className="space-y-1">
                  {displayGame}
                </div>

                {/* Bet Choice */}
                <div className="mt-1.5 pt-1.5 border-t border-[#228B22]/20">
                  <div className="flex items-center justify-between">
                    <span className="text-gray-600 font-medium text-[10px]">Your Choice:</span>
                    <div className="bg-gradient-to-r from-[#228B22] to-emerald-600 text-white px-2 py-0.5 rounded-full text-[10px] font-bold">
                      {match?.home === true && bettedTeam}
                      {match?.away === true && bettedTeam}
                      {match?.overs === true && t("goalOver")}
                      {match?.under === true && t("goalUnder")}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Footer Summary */}
      <div className="relative z-10 bg-gradient-to-r from-[#228B22] via-emerald-600 to-[#1F5F1F] px-3 py-2 shadow-sm">
        <div className="bg-white/90 rounded-xl px-3 py-2 border border-white/30">
          <div className="mb-1">
            <div className="bg-gradient-to-r from-[#FFD700] to-yellow-400 text-gray-900 text-center py-1.5 rounded-lg font-bold text-xs shadow-sm">
              {t("betAmount")}: {parseInt(selectedMatchesDetail?.amount || 0).toLocaleString()}
            </div>
          </div>
          {selectedMatchesDetail?.gamblingTypeId === 2 && (
            <div className="bg-white/70 rounded-lg py-1 border border-[#228B22]/20 text-center">
              <span className="text-gray-700 font-semibold text-[10px]">
                {t("teamCount")}:
                <span className="font-bold text-[#228B22] ml-1 text-xs">
                  {selectedMatchesDetail?.teamCount ?? "-"}
                </span>
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SelectedMathesDetail;
